import React from 'react';
import Image from 'next/image';
import { imageLoader } from '@/utils/imageLoader';
import {
    ImageTextWrapper,
    ImageWrapper,
    CarServicesHeading,
    CarServicesSubText,
    HeadingsWrapper,
} from './styles';

interface HeadingsProps {
    heading: string;
    subText?: string;
    logo?: any;
    isLandingPage?: boolean;
}

const Headings: React.FC<HeadingsProps> = ({
    heading,
    subText,
    logo,
    isLandingPage,
}) => {
    return (
        <HeadingsWrapper>
            {logo ? (
                <ImageTextWrapper>
                    <ImageWrapper>
                        <Image
                            loader={imageLoader}
                            src={logo?.company_image_url?.data?.attributes?.url}
                            layout="fill"
                            alt={'Navigation'}
                            objectFit="cover"
                        />
                    </ImageWrapper>

                    <CarServicesHeading
                        dangerouslySetInnerHTML={{ __html: heading }}
                    />
                </ImageTextWrapper>
            ) : (
                <CarServicesHeading
                    isLandingPage={isLandingPage}
                    dangerouslySetInnerHTML={{ __html: heading }}
                />
            )}
            {subText && <CarServicesSubText>{subText}</CarServicesSubText>}
        </HeadingsWrapper>
    );
};

export default Headings;
